module.exports = __webpack_public_path__ + "img/bg-gleeder-mobile.536bba9d.png";